module.exports = __webpack_public_path__ + "img/avatar4.cb8442a3.png";